/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
// import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'
import store from '@/store'

// Routes
import paths from './paths'
// import {db} from '@/utils/firebase'
// import state from '../store/state';
// import state from '../store/state'


function route (path, view, name, meta) {
  return {
    name: name || view,
    path,
    component: (resolve) => import(
      `@/views/${view}.vue`
    ).then(resolve),
    meta: meta
  }
}

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  routes: paths.map(path => route(path.path, path.view, path.name, path.meta)).concat([
    { path: '/', redirect: '/' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})



router.beforeEach((to, from, next) => {
  // console.log('To is: ', to)
  // console.log('From is: ', from)
  // if (to.query.redirect && (to.query.redirect !== from.path) && store.getters.getUser && (from.path !== '/')) {
  //   next(to.query.redirect)
  // }
  // console.log(to.path)
  console.log('meta is:', to.meta)
  console.log('to is:', to)
  console.log('isLogged in router is:', store.getters.getIsLogged)
  if(to.meta.requiresAuth) {
    if(store.getters.getIsLogged == true) {
      next()
    } else {
      next({path:'/'})
    }
  } else {
    next()
  }

  
})

Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
// if (process.env.GOOGLE_ANALYTICS) {
//   Vue.use(VueAnalytics, {
//     id: process.env.GOOGLE_ANALYTICS,
//     router,
//     autoTracking: {
//       page: process.env.NODE_ENV !== 'development'
//     }
//   })
// }

export default router
